var map = {
	"./John_John-w.png": "f0bb",
	"./adds.svg": "70b8",
	"./avatar.png": "83de",
	"./avatar.svg": "3873",
	"./banner.jpg": "3005",
	"./banner1.jpg": "bb59",
	"./banner2.jpg": "b23e",
	"./bg-le-lis-blang.jpg": "6374",
	"./bobo-w.png": "2b17",
	"./bobo.jpg": "25f5",
	"./corporativas.jpg": "9025",
	"./dudalina-w.png": "b9c4",
	"./dudalina.jpg": "9ddf",
	"./individual-w.png": "ecd9",
	"./individual.jpg": "3597",
	"./industria.jpg": "9f66",
	"./johnjohn.jpg": "8ad1",
	"./lelisblang-w.png": "d65e",
	"./logo-restoque.png": "53b7",
	"./logo_John_John.png": "591f",
	"./logo_bobo.png": "3d67",
	"./logo_dudalina.png": "622e",
	"./logo_individual.png": "4c1a",
	"./logo_le lis_blanc.png": "3b9b",
	"./logo_le-lis_blanc.png": "ab1c",
	"./loja.jpg": "11d2",
	"./m1.svg": "6dfe",
	"./m2.svg": "873a",
	"./m3.svg": "4170",
	"./m4.svg": "d117",
	"./m5.svg": "4f03",
	"./m6.svg": "6c0a",
	"./m7.svg": "fbdd",
	"./m8.svg": "e5ab",
	"./op1.png": "2576",
	"./op2.png": "24de",
	"./op3.png": "1668",
	"./p1.svg": "8edd",
	"./p2.svg": "6634",
	"./p3.svg": "9711",
	"./p4.svg": "16ba",
	"./rosa_cha-w.png": "ac65",
	"./rosa_cha.png": "0f58",
	"./rosacha.jpg": "c371"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a1b5";